import { Component } from '@angular/core';
import { AppComponent } from '../app.component';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { DataserviceService } from '../dataservice.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-imports',
  templateUrl: './imports.component.html',
  styleUrl: './imports.component.css'
})
export class ImportsComponent {

  user: any;

  importHistory: any[] = [];
  // selectedBatch: any = null;
  spinner: boolean = false;
  currentUser: any;
  pendingPayLoad: boolean = false;
  // showModal: boolean = false;
  payHierarchyExporting: boolean = false;
  environment = environment;

  imports = [
    { name: 'Pin Import', key: environment.licenseKeyPin, permission: this.checkPermission('pin_import') },
    { name: 'Fidium Master Import', key: environment.licenseKeyFidium, permission: this.checkPermission('fidium_master_import') },
    { name: 'Payroll Import', key: environment.licenseKeyFidium, permission: this.checkPermission('payroll_import') },
    { name: 'Payroll Mock Import', key: environment.licenseKeyMockPay, permission: this.checkPermission('payroll_mock_import') },
    { name: 'Provider Create Import', key: environment.licenseKeyCreate, permission: this.checkPermission('providers_import') },
    { name: 'Provider Update Import', key: environment.licenseKeyUpdate, permission: this.checkPermission('providers_import') },
    { name: 'Adjustment Import', key: environment.adjustmentKey, permission: this.checkPermission('providers_import') },
    { name: 'Pending Pay Import', key: environment.licenseKeyPendingPay, permission: this.checkPermission('payroll_import') },
    { name: 'Pay Hierarchy Import', key: environment.licenseKeyPayHierarchy, permission: this.checkPermission('payroll_import')},
    { name: 'User Provider Payplans', key: environment.licenseKeyProviderPayPlan, permission: this.checkPermission('payroll_import')},
    { name: 'Dish Customer Update', key: environment.licenseKeyDishUpdate, permission: this.checkPermission('payroll_import') }
  ]
  selectedImport: any;

  constructor(
    private app: AppComponent,
    private http: HttpClient,
    private data: DataserviceService,
    private modal: NzModalService,
    private message: NzMessageService
  ) { }

  ngOnInit() {
    this.spinner = true;
    const u = localStorage.getItem('user');
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    this.user = {
      user_id: u ? JSON.parse(u).crm_id : '',
      last_updated_by_user: u ? JSON.parse(u).id : ''
    }
    this.getImportBatches();
  }

  getImportBatches() {
    this.data.getData('fiber-pay-records/import-history')
      .subscribe({
        next: (res: any) => {
          // Sort by full import_date timestamp (newest first) - this will properly group files imported together
          this.importHistory = res.sort((a: any, b: any) => {
            // Sort by full import_date timestamp (descending - newest first)
            const dateA = new Date(a.import_date).getTime();
            const dateB = new Date(b.import_date).getTime();
            return dateB - dateA;
          });
          this.spinner = false;
        }
      })
  }

  imported(result: boolean, data: any) {
    this.spinner = true
    if (result) {
      // Check if this was a payroll mock import and show success message
      if (data?.import_type === 'payroll_mock') {
        this.message.success(`Payroll imported successfully! ${data.successful} records processed.`);
      }
      setTimeout(() => {
        this.getImportBatches();
      }, 1000);
    } else {
      this.message.error('Import failed. Please check your data format.');
      setTimeout(() => {
        this.getImportBatches();
      }, 1000);
    }
  }

  // viewBatchDetails(batch: any) {
  //   this.showModal = true;
  //   this.selectedBatch = batch;
  // }

  // handleCancel() {
  //   this.showModal = false;
  //   this.selectedBatch = null;
  // }

  checkPermission(permission: string) {
    return this.app.hasPermission(permission)
  }

  // Sort functions for nz-table
  sortByDate = (a: any, b: any) => {
    const dateA = new Date(a.import_date).getTime();
    const dateB = new Date(b.import_date).getTime();
    return dateA - dateB;
  }

  sortByFilename = (a: any, b: any) => {
    return a.filename.localeCompare(b.filename);
  }

  exportFailedRecords(batchId: string) {
    // Use HttpClient to get the blob data
    this.http.get(`${environment.baseUrl}export/failed-records/${batchId}`,
      { responseType: 'blob' }  // Important: specify blob response type
    ).subscribe({
      next: (blob: Blob) => {
        // Create a blob URL and trigger download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `failed_records_${new Date().toISOString()}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Failed to download CSV:', error);
      }
    });
  }


  showDeleteConfirm(batch: any): void {
    this.modal.confirm({
      nzTitle: 'Are you sure delete these imported records?',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.deleteBatch(batch),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }

  deleteBatch(batch: any) {
    this.spinner = true;
    this.data.postData({ id: batch.id }, 'work-order/delete-imported')
      .subscribe({
        next: (res: any) => {
          this.getImportBatches();
        }
      })
  }

  deletePending() {
    this.pendingPayLoad = true;
    this.modal.confirm({
      nzTitle: 'Are you sure delete pending pay?',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => {
        this.data.postData({}, 'pending-pay-import/delete')
          .subscribe({
            next: (res: any) => {
              this.pendingPayLoad = false;
              this.message.success(`Pending pay deleted!`);
            },
            error: (err: any) => {
              this.pendingPayLoad = false;
              this.message.error(`Failed to delete pending pay!`);
            }
          })
      },
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }

  exportPayHierarchy() {
    this.payHierarchyExporting = true;
    this.data.getData('pay-hierarchy/export').subscribe({
      next: (res: any) => {
        const csv = res?.data || '';
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `pay-hierarchy-${new Date().toISOString().split('T')[0]}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
        this.payHierarchyExporting = false;
      },
      error: () => {
        this.payHierarchyExporting = false;
        this.message.error('Failed to export pay hierarchy');
      }
    });
  }

}
